<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('p-super-admin')" id="about-main">
      <b-container fluid="lg">
        <div class="mb-3 p-2 border-bottom border-light">
          <h5 class="font-weight-light">
            <span><i class="fa-light fa-clipboard-list-check fa-lg"></i></span>
            Lista de Escolas
          </h5>
        </div>

        <Loading v-if="isLoading" class="middle-height-class" />
        <div v-else>
          <div class="custom-filters">
            <b-row no-gutters class="my-0 my-md-3">
              <b-col cols="3" md="1" lg="1" xl="1" class="mr-3 mr-md-4 mr-lg-3">
                <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"
                  class="mt-0 mb-3 mb-md-3 mb-lg-3" />
              </b-col>
              <b-col cols="12" md="8" lg="9" xl="9" class="ml-md-5 ml-lg-2" hidden>
                <b-form-group class="mb-3 mb-md-3 mb-lg-0">
                  <label>Filtrar por:</label>
                  <b-form-checkbox-group v-model="filterOn">
                    <b-form-checkbox size="sm" value="ID">ID</b-form-checkbox>
                    <b-form-checkbox size="sm" value="Nome">Nome</b-form-checkbox>
                    <b-form-checkbox size="sm" value="Usuario">Usuário</b-form-checkbox>
                    <b-form-checkbox size="sm" value="Ativo">Ativo</b-form-checkbox>
                    <b-form-checkbox size="sm" value="Inativo">Inativo</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="8" lg="5" xl="5" class="ml-md-5 ml-lg-0">
                <b-input-group class="mb-3 mb-md-0">
                  <b-form-input size="sm" type="text" id="filter-input" v-model="filter"
                    placeholder="Pesquisar"></b-form-input>
                  <b-input-group-append size="sm">
                    <b-button id="btn__clearFilter" :disabled="!filter" @click="filter = ''"><i
                        class="fa-regular fa-trash fa-lg"></i></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col cols="12" md="12" lg="5" xl="5" class="d-none d-md-block ml-md-0 ml-lg-5 ml-xl-5">
                <div class="d-flex align-items-center justify-content-lg-end">
                  <b-pagination class="ml-xl-5" size="md" v-if="totalRows > perPage" v-model="currentPage"
                    :total-rows="totalRows" :per-page="perPage" />
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- Main table element -->
          <b-table size="lg" id="table_schools" ref="school_table" class="custom-table" :items="acesso.data.dataScholl"
            :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter"
            :filter-included-fields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection" @filtered="onFiltered" :hover="true" responsive small>
            <template #cell(idUsuario)="rowData">
              {{ rowData.item.IdUser }}
            </template>
            <template #cell(activated)="rowData">
              <i class="fa-solid fa-circle fa-2xs text-success" v-if="rowData.item.status == 'Ativo'"
                v-b-tooltip.hover.top="rowData.item.status == 'Ativo' ? 'Usuário Ativo' : 'null'"></i>
              <i class="fa-solid fa-circle fa-2xs text-danger"
                v-else-if="rowData.item.status == 'Excluido' || rowData.item.status == 'Inativo'"
                v-b-tooltip.hover.top="rowData.item.status === 'Inativo' ? 'Usuário Inativo' : 'Usuário Excluído'"></i>
              <span v-else>Status Inválido</span>
            </template>
            <template #cell(created_at)="rowData">
              <small class="text-center">{{ rowData.item.dataDeRegistro | formatShortDate }}</small>
            </template>
            <template #cell(actions)="rowData">
              <b-button class="p-0" @click="info(rowData.item)" variant="transparent"
                v-b-tooltip.hover.top="'Ver mais'">
                <i class="fa-regular fa-eye"></i>
              </b-button>
              <!-- <div class="d-flex align-items-center justify-content-center">
                  <b-link class="mr-3" variant="transparent" hidden>
                    <i class="fa-regular fa-pen-to-square"></i>
                  </b-link>
                  <b-link variant="transparent" hidden>
                    <i class="fa-regular fa-trash"></i>
                  </b-link>
                </div> -->
            </template>
          </b-table>

          <b-modal :id="infoModal.id" size="lg" v-if="selectedItem" centered>
            <template #modal-title>
              {{ infoModal.title }}
            </template>
            <div class="p-3 border-bottom border-light">
              <span class="font-weight-bolder text-dark mr-2">ID:</span>
              <span>{{ selectedItem.IdUser }}</span>
            </div>
            <div class="p-3 border-bottom border-light">
              <span class="font-weight-bolder text-dark mr-2">Nome:</span>
              <span>{{ selectedItem.nome }}</span>
            </div>
            <div class="p-3 border-bottom border-light">
              <span class="font-weight-bolder text-dark mr-2">E-mail:</span>
              <span>{{ selectedItem.email }}</span>
            </div>
            <div class="p-3 border-bottom border-light">
              <span class="font-weight-bolder text-dark mr-2">Login:</span>
              <span>{{ selectedItem.login }}</span>
            </div>
            <div class="p-3 border-bottom border-light">
              <span class="font-weight-bolder text-dark mr-2">Status:</span>
              <span>{{ selectedItem.status }}</span>
            </div>
            <div class="p-3 border-bottom border-light">
              <span class="font-weight-bolder text-dark mr-2">Cadastro:</span>
              <span>{{ selectedItem.dataDeRegistro | formatShortDate }}</span>
            </div>
            <div class="p-3 border-bottom border-light">
              <span class="font-weight-bolder text-dark mr-2">Saldo:</span>
              <span v-if="selectedItem.saldo !== undefined">
                R$ {{ parseFloat(selectedItem.saldo).toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) }}
              </span>
            </div>
            <div class="p-3 border-bottom border-light">
              <span class="font-weight-bolder text-dark mr-2">Consumo:</span>
              <span v-if="selectedItem.consumo !== undefined">
                R$ {{ parseFloat(selectedItem.consumo).toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits:
                    2
                }) }}
              </span>
            </div>
            <div class="p-3">
              <span class="font-weight-bolder text-dark mr-2">Vencimento:</span>
              <span>{{ selectedItem.vencimento }}</span>
            </div>
            <template #modal-footer>
              <div>
                <span class="font-weight-bolder text-dark mr-2">Atualizado em:</span>
                <span>{{ selectedItem.updated_at | formatShortDate }}</span>
              </div>
            </template>
            <!-- <div class="p-2 bordezr-bottom border-light">
                <span class="font-weight-bolder text-dark mr-2">Consumo Anual:</span>
                <span v-if="selectedItem.consumoAnoAtual !== undefined">
                  R$
                  {{
                    parseFloat(selectedItem.consumoAnoAtual).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                </span>
              </div> -->

          </b-modal>

          <b-row>
            <b-col md="4"></b-col>
            <b-col md="4">
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill"
                class="my-0"></b-pagination>
            </b-col>
            <b-col md="4"></b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ApiService from '../../../../../common/api.service';
export default {
  name: 'super-pro-lista-escolas',
  metaInfo: { title: 'Lista de Escolas' },
  components: { Loading: () => import('@/components/loading.vue') },
  created() {
    this.loadData();
  },
  data() {
    return {
      isLoading: false,
      // theLoading: false,
      schoolSuperPro: '',
      acesso: { data: [] },
      fields: [
        { key: 'checkbox', label: '', sortable: false, class: 'text-center' },
        // { key: 'id', label: '#', sortable: false, class: 'text-center' },
        { key: 'idUsuario', label: 'ID', class: 'text-center' },
        { key: 'nome', label: 'Nome', },
        { key: 'login', label: 'Usuário', },
        { key: 'activated', label: 'Ativo', class: 'text-center' },
        { key: 'created_at', label: 'Cadastro', class: 'text-center' },
        { key: 'actions', label: 'Ações', class: 'text-center' },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 40, text: '40' },
        { value: 60, text: '60' },
        { value: 80, text: '80' },
        { value: 100, text: '100' }
      ],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: '',
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      showModal: false,
      selectedItem: null,
    };
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
    filteredData() {

      if (!this.filter || !this.filterOn.length) {
        return this.acesso.data.dataScholl
      }

      return this.acesso.data.dataScholl.filter(item => {
        return this.filterOn.some(filter => {
          if (filter === 'idUsuario' && item.idUsuario) return item.idUsuario.includes(this.filter);
          if (filter === 'Nome' && item.nome) return item.nome.toLowerCase().includes(this.filter);
          if (filter === 'Usuario' && item.login) return item.login.toLowerCase().includes(this.filter);
          if (filter === 'Ativo' && item.status === 'Ativo') return true;
          if (filter === 'Inativo' && (item.status === 'Inativo' || item.status === 'Excluido')) return true;

          return false
        })
      })

    }
  },
  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    async loadData() {
      this.isLoading = true
      this.schoolSuperPro = 'true';
      try {
        const response = await ApiService.post('v1/list-user-or-school', {
          school: this.schoolSuperPro,
        })
          .then(
            (response) => {
              this.acesso = response;
              this.totalRows = this.acesso.data.dataScholl.length;
            })
          .catch((error) => {
            console.error(error);
          })

      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    getTitle(key) {
      // Defina os títulos conforme necessário para cada campo
      const titles = {
        IdUser: 'ID',
        dataDeRegistro: 'Data de Registro',
        vencimento: 'Vencimento',
        saldo: 'Saldo',
        consumo: 'Consumo',
        consumoAnoAtual: 'Consumo Ano Atual',
        status: 'Status',
        // Adicione outros campos conforme necessário
      };
      return titles[key] || key; // Retorna o título ou o próprio key caso não esteja definido
    },
    showField(key) {
      // Defina quais campos devem ser exibidos
      const visibleFields = ['dataRegistro', 'vencimento', 'saldo', 'consumo', 'consumoAnoAtual', 'status'];
      return visibleFields.includes(key);
    },
    info(item, button) {
      this.infoModal.title = `Usuário: ${item.nome}`;

      (this.selectedItem = item), this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = '';
      this.infoModal.content = '';
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
.btn__show-modal {
  box-shadow: 0 0 3px rgba(67, 82, 98, 0.35);
  border: solid 1px #f3f5fc;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: 3px;

  color: #000000;
  background-color: #f3f5fc;

  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1.25px;
}

.btn__show-modal:hover {
  background-color: #d2d4f4;
  border-color: #d2d4f4;
  transition: all 0.35s ease;
  border-radius: 3px;
}

#btn__clearFilter {
  background-color: #ef4758;
  border-color: #ef4758;
  box-shadow: none;
}

#btn__clearFilter i {
  color: #5a37a7;
}

#btn__clearFilter.disabled {
  background-color: hsl(211, 20%, 79%);
  border-color: hsl(211, 20%, 79%);
}

#btn__clearFilter.disabled i {
  color: hsl(0, 0%, 44%);
}

.middle-height-class {
  height: auto;
}
</style>
